var map = {
	"./en/Comment.json": [
		3752,
		6
	],
	"./en/EmptyPlaceholder.json": [
		3753,
		7
	],
	"./en/Header.json": [
		3754,
		8
	],
	"./en/Headline.json": [
		3755,
		9
	],
	"./en/HeadlineList.json": [
		3756,
		10
	],
	"./en/NotFoundRoute.json": [
		3757,
		11
	],
	"./en/Settings.json": [
		3758,
		12
	],
	"./en/Submissions.json": [
		3759,
		13
	],
	"./en/Thread.json": [
		3760,
		14
	],
	"./en/User.json": [
		3761,
		15
	],
	"./en/shared.json": [
		3762,
		16
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 3721;
module.exports = webpackAsyncContext;